import { SvgIcon, SvgIconProps } from "@mui/material";

export const OpenExternalLinkIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
      <g clip-path="url(#a)">
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.2"
          d="M13.522 9.031v3.039c0 .802-.65 1.453-1.453 1.453H3.93c-.802 0-1.452-.65-1.452-1.453V3.93c0-.802.65-1.453 1.452-1.453h3.039M10.43 2.485l3.092-.008v3.087M6.156 9.855l6.891-6.891"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M2 2h12v12H2z" />
        </clipPath>
      </defs>
    </svg>
  </SvgIcon>
);
